import { LogSummary } from '../../Model/Log';
import { LogRepository, LogParams } from '../Repositories/LogRepository';

export class GetLogsSummaryUseCase {
  constructor(private repo: LogRepository) {}

  execute(params?: LogParams): Promise<LogSummary> {
    return this.repo
      .getLogsSummary(params)
      .then(r => r)
      .catch(err => Promise.reject(err));
  }
}
